import { LoadingContainer, Breadcrumb, Panels, Bar } from 'peach/components'
import { useParams, useRouteMatch } from 'peach/router'
import { getName } from 'peach/helpers'

import { DynamicForm, Page } from 'core/components'
import { useCompanyAppDomainGet, useCompanyAppDomainPut } from 'core/types'
import type { CompanyAppDomain } from 'core/types'

const AppDomain = () => {
  const { url } = useRouteMatch()
  const { companyId, appDomainId } = useParams<{
    companyId?: string
    appDomainId?: string
  }>()

  const {
    data: appDomain,
    isLoading,
    refetch,
  } = useCompanyAppDomainGet({
    companyId,
    companyAppDomainId: appDomainId,
  })

  const { mutateAsync: updateAppDomain } = useCompanyAppDomainPut({
    companyId,
    companyAppDomainId: appDomainId,
  })

  const onSubmit = async (payload: any) => {
    await updateAppDomain(payload as CompanyAppDomain)
    await refetch()
  }

  const title = getName(appDomain) || appDomain?.domain || 'App Domain'

  return (
    <Panels header={<Bar title={title} />}>
      <LoadingContainer isLoading={isLoading}>
        <Breadcrumb title={title} to={url} />

        <Page variant='full'>
          <DynamicForm
            data={appDomain || {}}
            fieldEditMode='toggle'
            fieldOverrides={{
              type: 'Select',
            }}
            omitFields={['id', 'companyId']}
            onSubmit={onSubmit}
            selectOptions={{
              type: [
                { label: 'Borrower', value: 'borrower' },
                { label: 'Agent', value: 'agent' },
                { label: 'Help', value: 'help' },
                { label: 'Admin', value: 'admin' },
              ],
            }}
          />
        </Page>
      </LoadingContainer>
    </Panels>
  )
}

export default AppDomain
